import { createSlice } from '@reduxjs/toolkit';

import type { ICommercialLink } from 'shared/types/commercialLinks';

/** Данные приходят только из SSR (preloadedState), экшенов нет */
const commercialLinksSlice = createSlice({
  initialState: [] as ICommercialLink[],
  name: 'commercialLinks',
  reducers: {},
});

export const { reducer: commercialLinksReducer } = commercialLinksSlice;
